import CloseIcon from '../../assets/svg/close.svg';
import ContactUs from '../../assets/svg/ContactUs.svg';
import ContactUsSelected from '../../assets/svg/ContactUs_selected.svg';
import Faq from '../../assets/svg/FAQ.svg';
import FAQSelected from '../../assets/svg/FAQselected.svg';
import HomeIcon from '../../assets/svg/home.svg';
import HomeIconSelected from '../../assets/svg/home_selected.svg';
import Profile from '../../assets/svg/profile.svg';
import ProfileSelected from '../../assets/svg/profile_selected.svg';
import Complaint from '../../assets/svg/raise_complaint.svg';
import ComplaintSelected from '../../assets/svg/raise_complaint_selected.svg';
import Signout from '../../assets/svg/Sign-out.svg';
import DocumentDownload from '../../assets/svg/startIcon.svg';
import DocumentDownloadSelected from '../../assets/svg/startIconSelected.svg';
import Tc from '../../assets/svg/TnC.svg';
import TCSelected from '../../assets/svg/TnC_selected.svg';
import {useMenuVisibility} from '../../hooks/useMenuVisibility';
import {UK_COUNTRY_CODE, MENU_OPTIONS_UNLEASH_KEY} from '../../utils/constant';
import {Navigate} from '../../utils/util';

import {List, ListItemButton, ListItemIcon} from '@mui/material';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import './BurgerMenu.css';
const BurgerMenu = ({
  setIsMenuOpen,
  selectedMenu,
  setVisible,
  contractNumberError,
  countryCode,
  noScheduleData,
  contractNumbers,
}) => {
  const {t} = useTranslation();
  const {flag: sidebarFlag, isItemVisible} = useMenuVisibility(
    MENU_OPTIONS_UNLEASH_KEY
  );

  const menuItem = [
    {
      title: 'MY_ACCOUNT',
      menuName: 'myAccount',
      icon: <img src={Profile} alt="profile icon" />,
      selectedIcon: <img src={ProfileSelected} alt="profile selected icon" />,
      isVisible: !sidebarFlag || isItemVisible('myAccount'),
    },
    {
      title: 'DOWNLOADS',
      menuName: 'download',
      icon: <img src={DocumentDownload} alt="document download icon" />,
      selectedIcon: (
        <img
          src={DocumentDownloadSelected}
          alt="document download selected icon"
        />
      ),
      isVisible:
        (contractNumbers?.contractCounts > 0 ||
          contractNumbers?.pastContractsCounts > 0) &&
        !contractNumberError?.isError &&
        (!sidebarFlag || isItemVisible('download')),
    },
    {
      title: 'CONTACT_US',
      menuName: 'contact',
      icon: <img src={ContactUs} alt="contact us icon" />,
      selectedIcon: (
        <img src={ContactUsSelected} alt="contact us selected icon" />
      ),
      isVisible: !sidebarFlag || isItemVisible('contact'),
    },
    {
      title: 'FAQ',
      menuName: 'leaseFAQ',
      icon: <img src={Faq} alt="faq icon" />,
      selectedIcon: <img src={FAQSelected} alt="faq selected icon" />,
      isVisible: !sidebarFlag || isItemVisible('leaseFAQ'),
    },
    {
      title: 'LEGAL_INFORMATION',
      menuName: 'legalInformation',
      icon: <img src={Tc} alt="legal information icon" />,
      selectedIcon: (
        <img src={TCSelected} alt="legal information selected icon" />
      ),
      isVisible: !sidebarFlag || isItemVisible('legalInformation'),
    },
    {
      title: 'RAISE_COMPLAINT',
      menuName: 'raiseComplaint',
      icon: <img src={Complaint} alt="raise complaint icon" />,
      selectedIcon: (
        <img src={ComplaintSelected} alt="raise complaint selected icon" />
      ),
      isVisible:
        countryCode === UK_COUNTRY_CODE &&
        !contractNumberError?.isError &&
        (!sidebarFlag || isItemVisible('raiseComplaint')),
    },
    {
      title: 'SIGN_OUT',
      menuName: 'signout',
      icon: <img src={Signout} alt="sign out icon" />,
      selectedIcon: <img src={Signout} alt="sign out icon" />,
      isVisible: true,
      handleOnClick: () => setVisible(true),
    },
  ];
  return (
    <div className={'BurgerMenuWrapper'}>
      <div className="topMenuItem">
        <div className="closeIcon">
          <img
            src={CloseIcon}
            alt="close icon"
            onClick={() => setIsMenuOpen(false)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                setIsMenuOpen(false);
              }
            }}
            role="button"
            tabIndex={0}
            aria-label="Close menu"
            data-testid="closeIcon"
          />
        </div>
        <div className="burgerMenuContent">
          <List aria-label="Burger-menu" disablePadding>
            {menuItem.map((item, index) => (
              <>
                {item.isVisible && (
                  <ListItemButton
                    key={item.menuName}
                    id="burgerListItem"
                    selected={selectedMenu === item.menuName}
                    onClick={() => {
                      item?.handleOnClick && item?.handleOnClick();
                      if (!item.handleOnClick) {
                        (item.menuName === 'myAccount' ||
                          item.menuName === 'contact' ||
                          item.menuName === 'legalInformation' ||
                          item.menuName === 'raiseComplaint' ||
                          item.menuName === 'leaseFAQ' ||
                          item.menuName === 'download') &&
                          Navigate(item.menuName);
                      }
                      setIsMenuOpen(false);
                    }}
                  >
                    <ListItemIcon>
                      {selectedMenu === item.menuName
                        ? item.selectedIcon
                        : item.icon}
                    </ListItemIcon>
                    <span
                      className={`list-item ${
                        selectedMenu === item.menuName && 'selected'
                      }`}
                    >
                      {t(item.title)}
                    </span>
                  </ListItemButton>
                )}
              </>
            ))}
          </List>
        </div>
      </div>
      {noScheduleData ? null : (
        <div className="bottomMenuItem">
          <List aria-label="Burger-menu" disablePadding>
            <ListItemButton
              selected={selectedMenu === 'home'}
              onClick={() => {
                Navigate('home');
                setIsMenuOpen(false);
              }}
              disabled={noScheduleData}
            >
              <ListItemIcon>
                {selectedMenu === 'home' ? (
                  <img src={HomeIconSelected} alt="home selected icon" />
                ) : (
                  <img src={HomeIcon} alt="home icon" />
                )}
              </ListItemIcon>
              <span
                className={`list-item ${selectedMenu === 'home' && 'selected'}`}
              >
                {t('HOME')}
              </span>
            </ListItemButton>
          </List>
        </div>
      )}
    </div>
  );
};

export const mapStateToProps = (state) => {
  return {
    countryCode: state.appStates.allContracts?.countryCode,
    noScheduleData: state.appStates?.noScheduleData,
    contractNumbers: state.appStates?.contractNumbers,
  };
};
export default connect(mapStateToProps)(BurgerMenu);
